import {h} from 'preact';
import isEmptyOrNil from '@util/fn/isEmptyOrNil';
import Menu from '../';

const Item = props => {
    const hasMenu = (props.sysId && !isEmptyOrNil( props.children ));
    const Component = hasMenu ? Menu.itemNode : Menu.itemLeaf;
    return <Component {...props}/>;
};

export default Item;